<template>
  <div
    class="dialog-container"
    ref="dialog"
    :class="{ 'dialog-center': instanceInfo.isCenter }"
    :style="popupStyle"
  >
    <div class="dialog-gray-bg" @click="doFullClose"></div>
    <component
      v-if="components"
      v-bind:is="components"
      @doCancel="doCancel"
      @doComfirm="doComfirm"
      :info="data"
    ></component>
  </div>
</template>
  <script>
import CustomButton from "@/components/unit/CustomButton";
import { defineAsyncComponent } from "vue";
export default {
  name: "myDdialog",
  components: {
    CustomButton,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    doCancel: {
      type: Function,
      default: () => {},
    },
    doComfirm: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      popupStyle: "",
      instanceInfo: {
        link: "", // 必传
        isCenter: true,
        isFullScreen: false, // 是否全屏
        isFullScreenClose: true, // 是否支持全屏关闭
      },
    };
  },
  created() {
    this.$nextTick(() => {
      let clientWidth = window.innerWidth;
      let popupWidth = document.body.clientWidth;
      this.popupStyle = `width:calc(${popupWidth}px);left:${
        (clientWidth - popupWidth) / 2
      }px`;
    });
    this.instanceInfo = {
      ...this.instanceInfo,
      ...this.data,
    };
  },
  computed: {
    components() {
      return defineAsyncComponent(() =>
        import(`@/components${this.data.link}`)
      );
    },
  },
  methods: {
    doFullClose() {
      if (!this.data.isFullScreenClose) {
        this.doCancel(true);
      }
    },
  },
};
</script>
  <style>
.dialog-container {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2000;
  white-space: pre-wrap;
  line-height: 1.5;
}
.dialog-center {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.dialog-gray-bg {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.85);
  opacity: 0.5;
  position: absolute;
  top: 0;
  left: 0;
}
</style>